module.exports = __webpack_public_path__ + "static/media/22r.9648497c.JPG";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Deconstructed/22r.JPG
// module id = 318
// module chunks = 0